import { useEffect, useState } from "react";
import Spinner from "../../interface/Spinner";
import FaultCard from "./FaultCard"; // Assuming FaultCard handles both directions
import { useGetActiveFaults } from "@hooks/BWOS/useGetActiveFaults";
import styled from "styled-components";

const HorizontalContainer = styled.div`
  display: flex;
  width: calc(100vw - 19.8rem);
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding-left: 1rem;
  padding-bottom: 1rem;
  margin-top: 0.4rem;
  overflow-x: auto; /* Optional: Allows horizontal scrolling if there are many cards */
`;

const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-left: 1rem;
  padding-bottom: 1rem;
  margin-top: 0.4rem;
  overflow-y: auto; /* Optional: Allows vertical scrolling if there are many cards */
`;

const Heading = styled.text`
  color: var(--color-witron-blue);
  margin-left: 1rem;
`;

const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  margin-left: 1rem;
  justify-content: space-between;
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 0.8em;
  backdrop-filter: blur(30px);
  background-color: var(--backdrop-color);
  border: 1px solid var(--color-grey-200);
  cursor: pointer;
  box-shadow: var(--shadow-div-md);
`;

function ActiveFaultsCardStack({ direction = "horizontal" }) {
  const { data, isLoading, isError, error, refetch } = useGetActiveFaults();
  const [countdown, setCountdown] = useState(5);
  const [area, setArea] = useState("ALL");
  const areaValues = ["ALL", "HBW", "OPM", "CHILLED"];

  const handleAreaClick = () => {
    setArea((prevArea) => {
      const currentIndex = areaValues.indexOf(prevArea);
      const nextIndex = (currentIndex + 1) % areaValues.length;
      return areaValues[nextIndex];
    });
  };

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          refetch();
          return 5;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, [refetch, data]);

  // Check if the response indicated no content
  if (data && data.noContent) {
    return <div>No backlogged orders.</div>;
  }

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return <div>Error: {error.message}</div>;
  }

  const Container =
    direction === "horizontal" ? HorizontalContainer : VerticalContainer;

  return (
    <>
      <InfoContainer onClick={handleAreaClick}>
        <Heading>REFRESH: </Heading>
        {countdown}s <Heading>AREA: </Heading>
        {area}
      </InfoContainer>
      <Container>
        {data.data.map((fault) => (
          <FaultCard key={fault.id} fault={fault} direction={direction} />
        ))}
      </Container>
    </>
  );
}

export default ActiveFaultsCardStack;
